<template lang="pug">

    div(role="main")
        div.layoutWrapperImage.layoutWrapperRegistrationImage(v-if="page === 'registration'" aria-hidden="true")
        div.layoutWrapperImage.layoutWrapperAuthImage(v-if="page === 'auth'" aria-hidden="true")

        div.layoutWrapper

            div.content-wrapper

                // Logo
                logo-component(type="auth")

                // Horizontal line
                separator-component.color

                div.auth-form.c-form

                    // Description
                    div.description
                        slot(name="title")

                        div.pt-2
                            span {{ `${$t('auth.description[1]')} ` }}
                            span
                                a(
                                  href="mailto:info@chillanywhere.com"
                                ) info@chillanywhere.com

                    // Form
                    slot
</template>

<script>
    import Logo from '~components/Logo';
    import Separator from '~components/Separator';
    import VueTypes from 'vue-types';

    export default {
        components: {
            LogoComponent: Logo,
            SeparatorComponent: Separator
        },
        props: {
            page: VueTypes.string.def('')
        },
        computed: {
            showSignUp() {
                return this.$router.currentRoute.name === 'auth.login';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl";
    .layoutWrapper
        height: 100%
        min-height: 100vh
        display: flex
        flex-direction: column
        position: relative
        align-items: center
        justify-content: center
        background-color: rgba(2,35,65,0.4)
        z-index: 2


    .layoutWrapperRegistrationImage
       background-image: url("https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/3-min.jpg")

    .layoutWrapperAuthImage
       background-image: url("https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/2-min.jpg")

    .layoutWrapperRegistrationImage
    .layoutWrapperAuthImage
        position: fixed
        top: 0
        left: 0
        width: 100vw
        height: 100vh
        z-index: 1
        background-size: cover
        background-position: center center

    >>> a
        color: $theme.white

    .loginDescription
        text-align: center
        font-weight: 700
        font-size: 18px
        text-shadow: 0 0 5px $theme.primary

    .content-wrapper
        margin: 20px
        padding: 40px 20px
        background-color: $theme.info
        width: 520px
        border-radius: 10px

    .description
        margin-top: 40px
        margin-bottom: 28px
        font-size: 14px
        color: $theme.white

    @media screen and (max-width: $grid-breakpoints.sm - 1)

        .content-wrapper
            width: calc(100% - 30px)
            padding: 20px 10px
</style>
